import {LocationDataInterface} from "../interfaces/LocationDataInterface";

interface Args {
    locationData?: LocationDataInterface,
    setLocationData?: (data: LocationDataInterface) => void,
    disabled?: boolean,
    step?: string
}

export const locationFields = (args: Args) => {

    const {locationData, setLocationData, disabled, step} = args

    return [
        {
            name: 'address',
            label: 'Adres',
            type: 'text',
            value: locationData.address,
            disabled: disabled,
            required: true,
            onChange: (data: HTMLInputElement) => setLocationData({...locationData, address: data.value})
        },
        {
            name: 'number',
            label: 'Nummer',
            type: 'text',
            value: locationData.number,
            disabled: disabled,
            required: true,
            onChange: (data: HTMLInputElement) => {
                setLocationData({...locationData, number: data.value})
            }
        },
        {
            name: 'numberLetter',
            label: 'Letter',
            type: 'text',
            value: locationData.numberLetter,
            disabled: disabled,
            required: false,
            onChange: (data: HTMLInputElement) => {
                setLocationData({...locationData, numberLetter: data.value})
            }
        },
        {
            name: 'addition',
            label: 'Toevoeging',
            type: 'text',
            value: locationData.addition,
            disabled: disabled,
            required: false,
            onChange: (data: HTMLInputElement) => setLocationData({...locationData, addition: data.value})
        },
        {
            name: 'zipcode',
            label: 'Postcode',
            type: 'text',
            value: locationData.postalCode,
            disabled: true,
            required: false,
            hide: step === 'location',
            onChange: (data: HTMLInputElement) => setLocationData({...locationData, postalCode: data.value})
        },
        {
            name: 'city',
            label: 'Stad',
            type: 'text',
            value: locationData.city,
            disabled: true,
            hide: step === 'location',
            required: false,
            onChange: (data: HTMLInputElement) => setLocationData({...locationData, city: data.value})
        }
    ]
}
